import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import type { Client } from '~/api/clients/types';

import { AlertDialog, Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';
import { r, routes } from '~/providers/RouterProvider/router.routes';

import type { DialogHandles } from '../ClientsTable.hooks';

import { isClientEditable } from '../../utils';

type Props = {
  client: Client;
  dialogHandles: DialogHandles;
};

export const ClientOptionsCell = ({ client, dialogHandles }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'clients']);

  return (
    <Menu.Root>
      <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

      <Menu.List>
        {client.clientType === 'organisation' && (
          <Menu.Item icon="Visibility" onClick={() => navigate(r(routes.showClient, { clientId: client.id }))}>
            {t('clients:overview.rowActions.view')}
          </Menu.Item>
        )}

        {isClientEditable(client) && (
          <Menu.Item icon="Edit" onClick={() => navigate(r(routes.editClient, { clientId: client.id }))}>
            {t('common:actions.edit')}
          </Menu.Item>
        )}

        {client.clientType === 'private' && client.contacts[0] && (
          <Menu.Item icon="Edit" onClick={() => navigate(r(routes.editContact, { clientId: client.id, contactId: client.contacts[0].id }))}>
            {t('common:actions.edit')}
          </Menu.Item>
        )}

        {client.clientType === 'organisation' && (
          <Menu.Item icon="PersonAdd" onClick={() => navigate(r(routes.createContact, { clientId: client.id }))}>
            {t('clients:overview.rowActions.addContact')}
          </Menu.Item>
        )}

        <AlertDialog.Trigger
          handle={dialogHandles.deleteClientHandle}
          nativeButton={false}
          payload={client}
          render={<Menu.Item icon="Trash">{t('common:actions.delete')}</Menu.Item>}
        />
      </Menu.List>
    </Menu.Root>
  );
};
